export const TASKLIST_LOADING = "TASKLIST_LOADING";
export const TASKLIST_RESET = "TASKLIST_RESET";
export const GET_TASKLIST = "GET_TASKLIST";
export const GET_TASKLIST_SUCCESS = "GET_TASKLIST_SUCCESS";
export const GET_TASKLIST_FAIL = "GET_TASKLIST_FAIL";
export const DELETE_TASKLIST = "DELETE_TASKLIST"
export const DELETE_TASKLIST_SUCCESS = "DELETE_TASKLIST_SUCCESS"
export const DELETE_TASKLIST_FAIL = "DELETE_TASKLIST_FAIL"
export const UPDATE_TASKLIST = "UPDATE_TASKLIST"
export const UPDATE_TASKLIST_SUCCESS = "UPDATE_TASKLIST_SUCCESS"
export const UPDATE_TASKLIST_FAIL = "UPDATE_TASKLIST_FAIL"
export const ADD_NEW_TASKLIST = "ADD_NEW_TASKLIST"
export const ADD_TASKLIST_SUCCESS = "ADD_TASKLIST_SUCCESS"
export const ADD_TASKLIST_FAIL = "ADD_TASKLIST_FAIL"